import React from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion'

import {
	MAX_WIDTH,
	SPACERS,
} from 'utils/styleHelpers'

import WeedRaterLogo from './WeedRaterLogo'

const HeaderBar = styled.header`
	margin: 0 auto;
	max-width: ${MAX_WIDTH};
	padding-top: ${SPACERS.L};
	padding-right: ${SPACERS.L};
	padding-left: ${SPACERS.L};
`
const LogoWrapper = styled.div`
	height: auto;
	max-width: 342px;
`

const Header = () => (
	<div>
		<HeaderBar>
			<Link to='/'>
				<LogoWrapper>
					<WeedRaterLogo />
				</LogoWrapper>
			</Link>
		</HeaderBar>
	</div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js